import React from 'react';
import AuthAside, { AuthAsideLockFoot, AuthAsideTrustFoot } from './AuthAside';

export const loginAside = (
  <AuthAside
    eyebrow="AI Lead Nurturing"
    title={
      <>
        Welcome to
        <br />
        Nurturer.
      </>
    }
    subtitle="The AI-powered assistant that keeps you in the conversation — long after the first call."
    benefits={[
      'Stay top of mind, automatically',
      'Save time, close more',
      'Never miss a warm lead',
    ]}
    foot={<AuthAsideTrustFoot />}
  />
);

export const registerAside = (
  <AuthAside
    eyebrow="AI Lead Nurturing"
    title={
      <>
        Keep every
        <br />
        lead warm.
      </>
    }
    subtitle="Nurturer researches, drafts, and schedules thoughtful touches for the contacts you didn't close — on your behalf."
    benefits={[
      'Personalized articles & touches',
      'Set the cadence, we handle the rest',
      'You approve before anything sends',
    ]}
    foot={<AuthAsideTrustFoot />}
  />
);

export const forgotAside = (
  <AuthAside
    eyebrow="Account recovery"
    title={
      <>
        Reset your
        <br />
        password.
      </>
    }
    subtitle="We'll email you a secure link to set a new password. The link expires in 30 minutes for your safety."
    benefits={[
      'Click "Send reset email" above',
      'Open the link in your inbox',
      'Choose a new password & sign in',
    ]}
    foot={<AuthAsideLockFoot />}
  />
);
